import { Component, inject, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { StateService } from '@adgate/common/services/state-service';
import { AuthenticationService } from '@adgate/common/services/authentication-service';
import { Privilege } from '@adgate/modules/admin/types/privilege.type';
import { DialogService } from '@adgate/common/services/dialog-service';
import { ChangePasswordDialogComponent, ChangePasswordDialogResult } from '../change-password-dialog-component/change-password-dialog-component';
import { filter, of, switchMap } from 'rxjs';
import { RESTApplicationResponse } from '@adgate/common/types/rest-application-response.type';

@Component({
  selector: 'app-user-profile-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule
  ],
  templateUrl: './user-profile-dialog-component.html',
  styleUrl: './user-profile-dialog-component.scss',
})
export class UserProfileDialogComponent implements OnInit 
{
  public state: StateService = inject(StateService);
  public authService: AuthenticationService = inject(AuthenticationService);
  private dialogRef: MatDialogRef<UserProfileDialogComponent> = inject(MatDialogRef<UserProfileDialogComponent>);
  private dialogService: DialogService = inject( DialogService );

  userAttributes!: any;
  modules: any[] = [];

  constructor() 
  {

  }

  ngOnInit(): void 
  {
    let decodedToken = this.authService.decodeToken( this.state.data.userToken );

    this.userAttributes = this.authService.getUserAttributes();
    this.modules.push({ name: 'TV / Radio', enabled: this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.COMM_VIEWHISTORY,Privilege.COMM_EDITHISTORY,Privilege.COMM_UPDATECOMMERCIAL,Privilege.COMM_UPLOADCOMMERCIAL]) });
    this.modules.push({ name: 'Streaming / Digital', enabled: this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.STRM_UPDATECREATIVITY,Privilege.STRM_UPDATEORDER,Privilege.STRM_UPLOADCREATIVITY,Privilege.STRM_VIEWHISTORY]) });
    this.modules.push({ name: 'Production', enabled: this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.PROD_UPDATEORDER,Privilege.PROD_UPDATEVERSION,Privilege.PROD_VIEWHISTORY]) });
    this.modules.push({ name: 'Admin Panel', enabled: this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_CREATEANYUSER,Privilege.ADMI_CREATEOFFICEUSERS,Privilege.ADMI_CREATEROLE,Privilege.ADMI_EDITAGENCIES,Privilege.ADMI_EDITOFFICEAGENCIES,Privilege.ADMI_EDITOFFICES]) });
  }

  decodeUserType(): string
  {
    switch( this.userAttributes.type ) {
      case 1: return 'Office User';
      case 2: return 'Agency User / Customer';
      case 3: return 'Administrator';
      default: return '';
    }
  }

  decodeOfficeAgency(): string
  {
    let s: string = '';

    if( this.userAttributes.office != null ) {
      s += this.userAttributes.office.description;
    }

    if( this.userAttributes.agency != null ) {
      s += (s != '' ? ' / ' : '' ) + this.userAttributes.agency.description;
    }

    return s;
  }

  onClose(): void
  {
    this.dialogRef.close();
  }

  onChangePassword(): void
  {
    let dialogData = {
      email: this.userAttributes.email,
      disableCurrentPassword: false
    };

    this.dialogService.openAnyDialog(ChangePasswordDialogComponent,{data: dialogData, width: '600px' }).afterClosed().pipe(
      filter((result: ChangePasswordDialogResult | null) => result !== null),
      switchMap((result:ChangePasswordDialogResult) => {
        this.dialogService.showProgress();
        return this.authService.updateUserPassword(result.currentPassword, result.newPassword);
      })
    ).subscribe({
      next: (r:RESTApplicationResponse) => {
        this.dialogService.openInfoDialog(r.message);
      },
      error: (err:Error) => {
        this.dialogService.openErrorDialog(err.message);
      }
    });
  }
}
